import { render, staticRenderFns } from "./standard-process-new-edit.vue?vue&type=template&id=4fee414a&scoped=true"
import script from "./standard-process-new-edit.vue?vue&type=script&lang=js"
export * from "./standard-process-new-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fee414a",
  null
  
)

export default component.exports